/* eslint-disable @typescript-eslint/no-explicit-any */
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { defineChain } from 'viem';
import { http } from 'viem';

// Define WATR Testnet chain
export const watrTestnet = defineChain({
  id: 92870,
  name: 'WATR Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'WATR',
    symbol: 'WATR',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.testnet.watr.org/XQaJWUCOGOXaPJOt4ros/ext/bc/2ZZiR6T2sJjebQguABb53rRpzme8zfK4R9zt5vMM8MX1oUm3g/rpc'],
    },
  },
  blockExplorers: {
    default: {
      name: 'WATR Explorer',
      url: 'https://explorer.testnet.watr.org',
    },
  },
});

// Define supported chains - using WATR Testnet
export const chains = [watrTestnet] as const;

// Create Wagmi config with RainbowKit
export const wagmiConfig = getDefaultConfig({
  appName: 'Encrypt ERC v2',
  projectId: (import.meta as any).env?.VITE_REOWN_PROJECT_ID,
  chains,
  transports: {
    [watrTestnet.id]: http('https://rpc.testnet.watr.org/XQaJWUCOGOXaPJOt4ros/ext/bc/2ZZiR6T2sJjebQguABb53rRpzme8zfK4R9zt5vMM8MX1oUm3g/rpc'),
  },
  ssr: false, // We're using Vite, not Next.js
});

// Export chain IDs for easy reference
export const SUPPORTED_CHAIN_IDS = chains.map(chain => chain.id);

// Chain configuration helpers
export const getChainById = (chainId: number) => {
  return chains.find(chain => chain.id === chainId);
};

export const isChainSupported = (chainId: number) => {
  return SUPPORTED_CHAIN_IDS.includes(chainId as any);
};